import React__default from 'react';
import classnames from 'classnames';
import styles from './styles.css.js';

var Controls = function Controls(_a) {
  var controls = _a.controls,
      conversationId = _a.conversationId,
      onAttach = _a.onAttach,
      onAppendText = _a.onAppendText,
      collapsed = _a.collapsed,
      onError = _a.onError;
  return React__default.createElement(React__default.Fragment, null, controls.map(function (Control, index) {
    var _a;

    return React__default.createElement("div", {
      key: index,
      className: classnames(styles.control, styles.flat, (_a = {}, _a[styles.collapsed] = collapsed, _a))
    }, React__default.createElement(Control, {
      conversationId: conversationId,
      attach: onAttach,
      appendText: onAppendText,
      onError: onError
    }));
  }));
};

export default Controls;
//# sourceMappingURL=index.js.map
